import { getSuspenseFallback } from '../../helpers/layout';
import { ErrorAlert } from '../ErrorAlert';

import { Error } from './styled';
import type { Props } from './types';

export function LayoutLoading({
  children,
  isError,
  isLoading,
  message,
  size = 'small',
}: Props) {
  if (isError || message) {
    return (
      <Error size={size}>
        <ErrorAlert
          message={message}
          size={size}
          sx={{
            ...(size === 'small'
              ? {
                  maxWidth: '320px',
                }
              : {}),
          }}
        />
      </Error>
    );
  }

  if (isLoading) {
    return getSuspenseFallback(size);
  }

  return (children ?? null) as React.ReactElement;
}
